import React from "react";
// import ApexCharts from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import getChartDefultOption from "../../utils/getChartDefultOption";
import ChartDateOfWeek from "./ChartDateOfWeek";
import ChartLegend from "./ChartLegend";
const RatingChart = ({ categories, series }) => {
  const options = getChartDefultOption({
    id: "chart--RatingChart",
    categories,
  });
  const legend = (function () {
    const rating5 = series[4]?.data?.reduce((a, b) => a + b, 0);
    const rating4 = series[3]?.data?.reduce((a, b) => a + b, 0);
    const rating3 = series[2]?.data?.reduce((a, b) => a + b, 0);
    const rating2 = series[1]?.data?.reduce((a, b) => a + b, 0);
    const rating1 = series[0]?.data?.reduce((a, b) => a + b, 0);    
    const sum = rating1 + rating2 + rating3 + rating4 + rating5;
    const f = x => sum ? Math.round((x / sum) * 100) : 0
    const percent5 = f(rating5);
    const percent4 = f(rating4);
    const percent3 = f(rating3);
    const percent2 = f(rating2);
    const percent1 = f(rating1);    
    return [
      ["5점", rating5 + "개", `(${percent5}%)`],
      ["4점", rating4 + "개", `(${percent4}%)`],
      ["3점", rating3 + "개", `(${percent3}%)`],
      ["2점", rating2 + "개", `(${percent2}%)`],
      ["1점", rating1 + "개", `(${percent1}%)`],
    ];
  })();
  return (
    <div>
      <div id="chart--RatingChart">
        <ReactApexChart options={options} series={series} type="bar" />
      </div>
      {/* <div id="html-dist"></div> */}
      <ChartDateOfWeek />
      <ChartLegend ls={legend} />
    </div>
  );
};

export default RatingChart;
